import { COMMONSTATUS_REDUCER_NAME } from './Constants';

const useSavedEditorSelector = ({ [COMMONSTATUS_REDUCER_NAME]: isSave }) => isSave;

const useTriggerResizeSelector = ({ [COMMONSTATUS_REDUCER_NAME]: resizeTrigger }) => resizeTrigger;

export { useSavedEditorSelector, useTriggerResizeSelector };
